import { connect, ConnectedProps } from 'react-redux';
import { AppState } from '../../../interfaces';
import { API_KEYS } from '../../../interfaces/api';
import { getApiState } from '../../../redux/selectors/common';
import { hideModal } from '../../../redux/slices/modal';
import { resetApiThunk } from '../../../redux/thunks/api';
import { thunks } from '../../../redux/thunks/thunks';
import PaymentMethod from './PaymentMethod';

const mapState = (state: AppState) => ({
  walletShipments: getApiState(
    state,
    API_KEYS.WALLET_TRANSACTIONS_SHIPMENT_HISTORY
  ),
  user: getApiState(state, API_KEYS.LOGIN),
  paymentLogState: getApiState(state, API_KEYS.ADD_WALLET_PAYMENT_LOG),
  verificationState: getApiState(state, API_KEYS.VERIFY_PAYMENT),
  paymentCountryState : getApiState(state, API_KEYS.GET_PAYMENTMETHOD_BY_COUNTRY),
  checkCellulantEncryptionState : getApiState(state, API_KEYS.CHECK_CELLULANT_ENCRYPTION),
  getEquivalentState : getApiState(state, API_KEYS.GET_CURRENCY_EQUIVALENT),
  getCheckoutState : getApiState(state, API_KEYS.GENERATE_CHECKOUT_URL)
});

const mapDispatch = {
  resetApi: resetApiThunk,
  hideModal,
  verifyPayment: thunks.VERIFY_PAYMENT,
  addWalletPaymentLog: thunks.ADD_WALLET_PAYMENT_LOG,
  getPaymentByCountry : thunks.GET_PAYMENTMETHOD_BY_COUNTRY,
  checkEncryption : thunks.CHECK_CELLULANT_ENCRYPTION,
  getEquivalent : thunks.GET_CURRENCY_EQUIVALENT,
  generateCheckout : thunks.GENERATE_CHECKOUT_URL
};

const connector = connect(mapState, mapDispatch);

export type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(PaymentMethod);
